import { Routes, RouterModule } from '@angular/router';
import { MetaGuard } from '@ngx-meta/core';
import { AcessibilidadeComponent } from './acessibilidade.component';
import { environment } from '../../environments/environment';

export const router: Routes = [
  {
    path: '',
    canActivate: [MetaGuard],
    component: AcessibilidadeComponent,
    data: {
      meta: {
        title: environment.title+' - Acessibilidade',
        description: 'Serviços - Acessibilidade',
      },
    },
  },
];

export const AcessibilidadeRouter = RouterModule.forChild(router);
